import React from 'react';

import {observer} from 'mobx-react';
import {SliderController} from '../slider-controller';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {SliderComposer} from "./slider-composer";
import {SliderDesktop} from "./slider.desktop";
import {SliderMobile} from "./slider.mobile";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {SLIDER} from "../slider.consts";

export class SliderProps extends BaseProps {
  id: Number;
  speed: Number;
  height: Number;
  isRtl: Boolean;
  onSlide: Function;
  controller: SliderController;
  direction: String;
  showFirstTriangle: Boolean;
  showLastTriangle: Boolean;
  onArrowClick: Function;
  initialIndex: Number;
  CardComponent: React.Component;
  cardComponentProps: Object;
  items: Array<BaseViewModel>;
  emptyStateText: String;
  hasOdds: Boolean;
  blockInnerLinks: Boolean;
  isHandset: Boolean;
  ArrowComponent: React.Component;
  arrowComponentProps: Object;
  shouldRenderOverCardArrow: Boolean
  theme: SLIDER.THEMES
  shouldMoveItemsOnClick: Boolean;
  cardClassName: String;
}

export const Slider = SliderComposer(observer((props: SliderProps) => {
  return props.isHandset ? <SliderMobile {...props} /> : <SliderDesktop {...props} />
}));
